function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon_line/home_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15 11L11.25 15L9 13.1818",
    stroke: "#1FB567",
    style: {
      stroke: "#1FB567",
      stroke: "color(display-p3 0.1216 0.7098 0.4039)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 15 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8996 4.78288C12.747 3.87446 11.0864 3.87446 9.93374 4.78288L4.34472 9.18786C3.86271 9.56775 3.58333 10.135 3.58333 10.7336V17.9262C3.58333 19.0308 4.51607 19.9262 5.66667 19.9262H18.1667C19.3173 19.9262 20.25 19.0308 20.25 17.9262V10.7336C20.25 10.135 19.9706 9.56775 19.4886 9.18786L13.8996 4.78288ZM8.61179 3.2371C10.5328 1.72305 13.3005 1.72305 15.2215 3.2371L20.8106 7.64208C21.7746 8.40186 22.3333 9.53627 22.3333 10.7336V17.9262C22.3333 20.1353 20.4679 21.9262 18.1667 21.9262H5.66667C3.36548 21.9262 1.5 20.1353 1.5 17.9262V10.7336C1.5 9.53627 2.05876 8.40186 3.02277 7.64208L8.61179 3.2371Z",
    fill: "#1FB567",
    style: {
      fill: "#1FB567",
      fill: "color(display-p3 0.1216 0.7098 0.4039)",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.ec34e83d24938587267e902d9c49d0c3.svg";
export { ForwardRef as ReactComponent };